import React, { useEffect, useRef, useState } from "react";

const LeadConversionInfo = (props) => {
  const infoForm = useRef(null);
  const [leadsInfoData, setLeadsInfoData] = useState({});
  const [timeline, setTimeline] = useState("TODAY");
  const [searchdata, setSearchdata] = useState({});

  const leadsInfoCardData = [
    {
      id: "interested",
      title: "Interested",
      count: leadsInfoData?.interestedLeads || 0,
      icon: imagepaths.AdminLeadsIconActive,
      // path: `/app/portfolioinfo?cardname=totalleads&tablename=leads&timeline=${
      //   searchdata?.start_date ? "CUSTOM" : timeline
      // }&start_date=${searchdata?.start_date || null}&end_date=${
      //   searchdata?.end_date || null
      // }`,
    },
    {
      id: "applied",
      title: "Applied",
      count: leadsInfoData?.appliedLeads || 0,
      icon: imagepaths.userWarningIcon,
      // path: `/app/portfolioinfo?cardname=digital&tablename=leads&timeline=${
      //   searchdata?.start_date ? "CUSTOM" : timeline
      // }&start_date=${searchdata?.start_date || null}&end_date=${
      //   searchdata?.end_date || null
      // }`,
    },
    {
      id: "disbursed",
      title: "Disbursed",
      count: leadsInfoData?.disbursedLeads || 0,
      icon: imagepaths.userCheckmarkIcon,
      // path: `/app/portfolioinfo?cardname=offline&tablename=leads&timeline=${
      //   searchdata?.start_date ? "CUSTOM" : timeline
      // }&start_date=${searchdata?.start_date || null}&end_date=${
      //   searchdata?.end_date || null
      // }`,
    },
    {
      id: "disbursementAmount",
      title: "Disbursement  Amt.",
      count: leadsInfoData?.disbursementAmt || 0,
      icon: imagepaths.userRightIcon,
      // path: `/app/portfolioinfo?cardname=enquiry&tablename=leads&timeline=${
      //   searchdata?.start_date ? "CUSTOM" : timeline
      // }&start_date=${searchdata?.start_date || null}&end_date=${
      //   searchdata?.end_date || null
      // }`,
    },
  ];

  // ADMIN LEADS INFO
  const getAdminLeadsInfo = (query, params) => {
    let data = {
      ...query,
    };

    let payload = {};
    if (params) {
      payload = {
        timeline: params,
      };
    } else {
      payload = {
        timeline: timeline,
      };
    }

    console.log({ params, data, timeline });

    props.apis.apiGetDashboardAdminLeadsConversionInfo(data, payload).then((res) => {
      setLeadsInfoData(res);
    });
  };

  const showInputs = (inputnames) => {
    if (inputnames.length > 0) {
      inputnames.forEach((id) => {
        const element = document.getElementById(id);
        if (element) {
          element.classList.remove("d-none");
        }
      });
    }
  };

  const hideInputs = (inputnames) => {
    if (inputnames.length > 0) {
      inputnames.forEach((id) => {
        const element = document.getElementById(id);
        if (element) {
          element.classList.add("d-none");
        }
      });
    }
  };

  const handleDateChange = (value) => {
    let val = value[0]?.key || "TODAY";
    let inputs = [
      "leadconversion-column-start_date",
      "leadconversion-column-end_date",
      "leadconversion-column-search_btn",
      "leadconversion-column-reset_btn",
    ];
    // console.log({ val });
    props.onTimelineChange(val);
    if (val === "CUSTOM") {
      showInputs(inputs);
      setLeadsInfoData({});
    } else {
      setTimeline(val);
      setSearchdata({});
      hideInputs(inputs);
    }
  };

  const onSearch = () => {
    let data = infoForm.current.form.current.getData();
    let queryData = {
      ...Object.except(data, ["timeline"]),
    };
    props.onCustomTimelineChange(queryData);
    setSearchdata(queryData);
    getAdminLeadsInfo(queryData, "CUSTOM");
  };

  const resetSearchForm = () => {
    infoForm?.current?.form?.current?.reset();
    let inputs = [
      "leadconversion-column-start_date",
      "leadconversion-column-end_date",
      "leadconversion-column-search_btn",
      "leadconversion-column-reset_btn",
    ];
    props.onCustomTimelineChange({});
    hideInputs(inputs);
    setSearchdata({});
    setTimeline("TODAY");
    getAdminLeadsInfo({}, "TODAY");
  };


  const handleDownloadExcel = async () => {
    let isCustom = false;
    try {
      let formData = infoForm.current?.form?.current?.getData();
      if (formData && formData.timeline) {
        let ft = formData.timeline;
        if (Array.isArray(ft)) {
          isCustom = ft[0]?.key === "CUSTOM";
        } else if (typeof ft === "string") {
          isCustom = ft === "CUSTOM";
        } else if (typeof ft === "object" && ft.key) {
          isCustom = ft.key === "CUSTOM";
        }
      }
    } catch (e) {
      console.error(e);
    }

    let data = isCustom ? {
      ...(searchdata.start_date
        ? {
          start_date: searchdata.start_date,
        }
        : {}),
      ...(searchdata.end_date
        ? {
          end_date: searchdata.end_date,
        }
        : {}),
    } : {};

    let payload = {
      timeline: isCustom ? "CUSTOM" : (timeline || "TODAY"),
    };
    const resolve = async (res, filename) => {
      let data = await res;
      let blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      let link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.setAttribute('download', `${filename}.xlsx`);
      link.click();
    };
    props.apis.apiExportDashboardAdminLeadsConversionInfo(data, payload).then(async (res) => {
      if (res) resolve(res, 'admin_leads_conversion_info');
    });
  };

  useEffect(() => {
    // ADMIN LEADS CONVERSION INFO
    getAdminLeadsInfo();
  }, [timeline]);

  props.$setNode({
    props,
    leadsInfoData,
  });
  return (
    <>
      <div className="mb-4 dashboard_form_box">
        <div className="action_btn_group text-end">
          <button
            type="button"
            className="btn btn-primary-transparent file_download_btn text-primary me-5"
            onClick={(...args) => handleDownloadExcel(...args)}
          >
            <i className="fa fa-download me-2"></i>
            Download Excel
          </button>
        </div>
        <div className="form_outer">
          <AppForm
            ref={infoForm}
            onSubmit={(...args) => onSearch(...args)}
            className="row justify-content-end"
          >
            <div
              className="col-12 col-md-3 col-lg-3 col-xl-2"
              id="column-timeline"
            >
              <AppInputFocus
                type="select"
                name="timeline"
                label="Time Line"
                options={_enum.OVERALL_DETAIL}
                onChange={(...args) => handleDateChange(...args)}
                defaultValue={"TODAY"}
                placeholder="Time Line"
              ></AppInputFocus>
            </div>
            <div
              className="col-12 col-md-3 col-lg-3 col-xl-2 d-none"
              id="leadconversion-column-start_date"
            >
              <AppInputFocus
                type="date"
                name="start_date"
                label="Start Date"
                placeholder="Start Date"
              ></AppInputFocus>
            </div>
            <div
              className="col-12 col-md-3 col-lg-3 col-xl-2 d-none"
              id="leadconversion-column-end_date"
            >
              <AppInputFocus
                type="date"
                name="end_date"
                label="End Date"
                placeholder="End Date"
              ></AppInputFocus>
            </div>
            <div
              className="col-2 col-md-1 col-lg-1 col-xl-1 d-none"
              id="leadconversion-column-search_btn"
            >
              <button type="submit" className="btn btn-primary search_btn">
                <i className="fa fa-search"></i>
                <span>Search</span>
              </button>
            </div>
            <div
              className="col-2 col-md-1 col-lg-1 col-xl-1 d-none"
              id="leadconversion-column-reset_btn"
            >
              <button
                type="button"
                className="btn btn-primary search_btn"
                onClick={(...args) => resetSearchForm(...args)}
              >
                <i class="fa-solid fa-filter-circle-xmark"></i>
                <span>Search</span>
              </button>
            </div>
          </AppForm>
        </div>
        <div className="row pt-0 pt-md-4">
          {leadsInfoCardData &&
            leadsInfoCardData.map((data) => {
              return (
                <>
                  <div className="col-xl-3 col-sm-6">
                    <div className="card dashboard_card">
                      <div className="border_bottom_line"></div>
                      <div className="card-body">
                        <div className="icon">
                          <img src={data?.icon} alt={data?.title} />
                        </div>
                        <div className="content">
                          <p className="count">{data?.count}</p>
                          <p className="card_label">{data?.title}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              );
            })}
        </div>
      </div>
    </>
  );
};

export default constore(LeadConversionInfo);
